// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-tab-bar .tab-list {
  display: flex;
  gap: 1rem;
}
.checkout-tab-bar .tab-list .tab {
  padding: 0.5rem 0;
  text-decoration: none;
  color: var(--gc-text-color);
  background-color: transparent;
  border-bottom: 2px solid var(--gc-color-medium);
  transition: all 0.2s;
  cursor: pointer;
  white-space: nowrap;
}
.checkout-tab-bar .tab-list .tab:hover {
  border-bottom-color: var(--gc-color-medium-shade);
}
.checkout-tab-bar .tab-list .tab.active {
  border-bottom-color: var(--gc-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/_purpose-built-components/checkout-tab-bar/checkout-tab-bar.component.sass"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,SAAA;AAAJ;AAEI;EACE,iBAAA;EACA,qBAAA;EACA,2BAAA;EACA,6BAAA;EACA,+CAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AAAN;AAEM;EACE,iDAAA;AAAR;AAEM;EACE,4CAAA;AAAR","sourcesContent":[".checkout-tab-bar\n  .tab-list\n    display: flex\n    gap: 1rem\n    \n    .tab\n      padding: 0.5rem 0\n      text-decoration: none\n      color: var(--gc-text-color)\n      background-color: transparent\n      border-bottom: 2px solid var(--gc-color-medium)\n      transition: all 0.2s\n      cursor: pointer\n      white-space: nowrap\n      \n      &:hover\n        border-bottom-color: var(--gc-color-medium-shade)\n      \n      &.active\n        border-bottom-color: var(--gc-color-primary)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
